import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Portal from 'react-portal'
import FileInput from 'react-file-input'
import update from 'immutability-helper'
import fetch from 'unfetch'
import set from 'lodash.set'
import robotLogo from './img/LLNR_logo.png'

const UserInformationModal = ({ close }) =>
  <div
    className="modal fade"
    role="dialog"
    style={{ display: 'block', opacity: 1 }}>
    <div className="modal-dialog" style={{ marginTop: 200 }}>
      <div className="modal-content">
        <div className="modal-header">
          <button type="button" className="close" onClick={close}>
            ×
          </button>
          <h4 className="modal-title">LLN Robot System User Roles</h4>
        </div>
        <div className="modal-body">
          <p style={{ color: 'black' }}>
            There are three distinct user roles available in the LLN Robot
            System:
          </p>
          <ul style={{ color: 'black' }}>
            <li>
              <strong>Enrolment Officer</strong>
              <br />
              This role is for administration assistants and staff who are
              involved with the enrolment process for learners.
            </li>
            <li>
              <strong>LLN Specialist</strong>
              <br />
              This role is for LLN specialists who are involved with the LLN
              assessment and support of learners.
            </li>
            <li>
              <strong>Administrator</strong>
              <br />
              This role is for the administrator of the LLN Robot System.
            </li>
          </ul>
          <img
            src="https://s3-ap-southeast-2.amazonaws.com/lln-robot-resources/img/5d99d5684a571bdcbe2a9968a2607f81.png"
            alt="Description of user roles."
            width="100%"
          />
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-default" onClick={close}>
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

class DeploymentRequest extends Component {
  newUser = () => ({
    name: {
      first: '',
      last: '',
    },
    email: '',
    role: '',
  })
  state = {
    userInformationModalOpen: false,
    form: {
      deploymentContact: {
        name: {
          first: '',
          last: '',
        },
        phone: '',
        email: '',
      },
      preferences: {
        dailyQuizCompletionEmails: true,
        immediateQuizCompletionEmails: true,
        learnerRedirectionURL: '',
        defaultQuizLevel: 'acsf4',
        learnerCorrespondence: {
          name: '',
          email: '',
          phone: '',
        },
        adminCorrespondence: {
          name: '',
          email: '',
        },
      },
      companyName: '',
      logo: '',
      requestedSubdomain: '',
      users: [this.newUser()],
    },
  }
  toggleUserInformationModal = () =>
    this.setState(({ userInformationModalOpen }) => ({
      userInformationModalOpen: !userInformationModalOpen,
    }))
  onChangeLogo = ({ target }) => {
    const { files } = target
    this.setFormValue('logo', files[0])
    this.setState({ logoError: null })
    if (FileReader) {
      const reader = new FileReader()
      if (reader.readAsDataURL) {
        reader.onload = e => {
          this.setState({ logoPreview: e.target.result })
        }
        reader.readAsDataURL(files[0])
      }
    }
  }
  onChangeCheck = ({ target }) => {
    this.setFormValue(target.name, target.checked)
  }
  onChange = ({ target }) => {
    this.setFormValue(target.name, target.value)
  }
  onChangeEmail = ({ target }) => {
    this.setFormValue(target.name, target.value.toLowerCase())
  }
  setFormValue = (key, value) =>
    this.setState(state => set(state, `form.${key}`, value))
  addAdminUser = () =>
    this.setState(
      update(this.state, { form: { users: { $push: [this.newUser()] } } }),
    )
  removeAdminUser = index => () =>
    this.setState(
      update(this.state, { form: { users: { $splice: [[index, 1]] } } }),
    )
  onSubmit = async e => {
    e.preventDefault()
    const { form: { logo, ...data } } = this.state
    if (!logo) {
      return this.setState({ logoError: 'Please upload a company logo.' })
    }
    this.setState({ logoError: null })
    this.setState({ submitting: true })
    const response = await fetch(
      'https://api.tlrg.com.au/api/deployment-request',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(data),
      },
    )
    if (!response.ok) {
      return this.setState({
        submitting: false,
        error: 'There was an error while submitting the form.',
      })
    }
    const { deploymentRequestId } = await response.json()
    this.setState({ submittingLogo: true })
    const formData = new FormData()
    formData.append('logo', logo)
    const logoResponse = await fetch(
      `https://api.tlrg.com.au/api/deployment-request/logo/${deploymentRequestId}`,
      {
        method: 'POST',
        body: formData,
      },
    )
    if (!logoResponse.ok) {
      return this.setState({
        submitting: false,
        error: 'There was an error while submitting your logo.',
      })
    }
    this.setState({ submitting: false, submitted: true })
  }
  render() {
    const {
      userInformationModalOpen,
      form,
      logoPreview,
      logoError,
      error,
      submitting,
      submitted,
    } = this.state
    let content

    if (error) {
      content = (
        <div style={{ textAlign: 'center', color: 'white' }}>
          <h2>
            An error occurred: {error}
          </h2>
        </div>
      )
    } else if (submitting) {
      content = (
        <div style={{ textAlign: 'center', color: 'white' }}>
          <h2>Submitting...</h2>
        </div>
      )
    } else if (submitted) {
      content = (
        <div className="col-md-8 col-md-offset-2" style={{ fontSize: '1.3em' }}>
          <p style={{ marginTop: 50 }}>
            Thank you for completing the LLN Robot System deployment information
            form.
          </p>
          <p style={{ marginTop: 20 }}>
            Once payment of your account has been made our deployment team will
            begin the process of creating your custom deployment. This can take
            up to 10 business days.
          </p>
          <p style={{ marginTop: 20 }}>
            You can contact us at any point if you have any questions on{' '}
            <a href="mailto:sales@tlrg.com.au?subject=LLN%20Robot%20System">
              sales@tlrg.com.au
            </a>{' '}
            or 1300 221 729.
          </p>
          <a
            href="http://tlrg.com.au/"
            className="btn btn-success btn-block"
            style={{ marginTop: 50, marginBottom: 50 }}>
            Go to tlrg.com.au
          </a>
        </div>
      )
    }

    return (
      <div>
        <Portal isOpened={userInformationModalOpen}>
          <UserInformationModal close={this.toggleUserInformationModal} />
        </Portal>
        <style>
          {`
            body {
                margin: -20px 0 0 0;
            }

            .background {
              z-index: -1;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              position: fixed;
              background-image: url("/img/bg.jpg");
              background-size: cover;
              background-repeat: no-repeat;
            }

            h1 {
                font-family: tahoma, geneva, sans-serif;
                font-weight: bolder;
                color: #FFC142;
                text-align: center;
                padding-bottom: 40px;
            }

            h3 {
                font-family: tahoma, geneva, sans-serif;
                font-weight: bolder;
                color: #FFC142;
            }

            h4 {
                font-family: tahoma, geneva, sans-serif;
                font-weight: bolder;
                color: #FFC142;
                display: inline-block;
            }

            h5 {
                font-family: tahoma, geneva, sans-serif;
                font-weight: bolder;
                color: #FFC142;
                display: inline-block;
            }

            p, label {
                color: #FFF;
            }

            a {
              color: #284f94;
            }

            .text-muted {
                color: #d8d8d8;
                font-style: italic;
                padding-bottom: 10px;
            }

            .contentdiv {
                background-image: url("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");
                border-radius: 10px 10px 10px 10px;
                -moz-border-radius: 10px 10px 10px 10px;
                -webkit-border-radius: 10px 10px 10px 10px;
                padding: 0px 30px;
                background-color: rgba(0, 0, 0, 0.25);
                margin-bottom: 10px;
            }

            .btn-file {
                position: relative;
                overflow: hidden;
            }

            .btn-file input[type=file] {
                position: absolute;
                top: 0;
                right: 0;
                min-width: 100%;
                min-height: 100%;
                font-size: 100px;
                text-align: right;
                filter: alpha(opacity=0);
                opacity: 0;
                outline: none;
                background: white;
                cursor: inherit;
                display: block;
            }
          `}
        </style>
        <Helmet title="LLN Robot System - Sign Up" />
        <div className="background" />
        <div className="container contentdiv" style={{ marginTop: 30 }}>
          <div style={{ margin: '20px 0', textAlign: 'center' }}>
            <img src={robotLogo} alt="LLN Robot System" height="80px" />
          </div>
          {content ||
            <form onSubmit={this.onSubmit} className="form-horizontal">
              <fieldset>
                <div className="row">
                  <div className="col-md-2" />
                  <div className="col-md-8">
                    <h3>LLN Robot System - Deployment Information</h3>
                    <p className="lead-text">
                      Please enter the information for your company below. If
                      you have any questions regarding this form or any of the
                      sections please call us on 1300 221 729.
                    </p>
                  </div>
                  <div className="col-md-2" />
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-4" />
                  <div className="col-md-6">
                    <h4>Deployment Contact</h4>
                    <p className="text-muted">
                      This will be our point of contact throughout the
                      deployment process and the first person we contact
                      regarding any changes or updates to the LLN Robot System.
                    </p>
                  </div>
                  <div className="col-md-2" />
                </div>

                <div className="row">
                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Contact First Name
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        name="deploymentContact.name.first"
                        value={form.deploymentContact.name.first}
                        type="text"
                        placeholder="e.g. John"
                        className="form-control input-md"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Contact Last Name
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        name="deploymentContact.name.last"
                        value={form.deploymentContact.name.last}
                        type="text"
                        placeholder="e.g. Smith"
                        className="form-control input-md"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Contact Phone Number
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        name="deploymentContact.phone"
                        value={form.deploymentContact.phone}
                        type="text"
                        placeholder="e.g. 1300 221 729"
                        className="form-control input-md"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Contact Email Address
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        name="deploymentContact.email"
                        value={form.deploymentContact.email}
                        type="email"
                        placeholder="e.g. support@tlrg.com.au"
                        className="form-control input-md"
                        required
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-4" />
                  <div className="col-md-6">
                    <h4>LLN Robot System Settings</h4>
                    <p className="text-muted">
                      These are the settings that your LLN Robot System will be
                      created with. These can be updated via your administration
                      section once your LLN Robot System has been deployed.
                    </p>
                  </div>
                  <div className="col-md-2" />
                </div>
                <div className="row">
                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Daily Quiz Summary Email
                    </label>
                    <div className="col-md-6">
                      <label>
                        <input
                          type="checkbox"
                          name="preferences.dailyQuizCompletionEmails"
                          onChange={this.onChangeCheck}
                          value={form.preferences.dailyQuizCompletionEmails}
                        />
                        Receive Daily Quiz Summary Email
                      </label>
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        This is a daily email containing a summary of the
                        learners who have completed a quiz within the last 24
                        hours. The Admin Correspondence Email (set below) will
                        receive these emails.
                      </p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Immediate Quiz Completion Emails
                    </label>
                    <div className="col-md-6">
                      <label>
                        <input
                          type="checkbox"
                          name="preferences.immediateQuizCompletionEmails"
                          onChange={this.onChangeCheck}
                          value={form.preferences.immediateQuizCompletionEmails}
                        />
                        Receive Immediate Quiz Completion Emails
                      </label>
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        This is an email that is sent out immediately after a
                        learner completes a quiz. The Admin Correspondence Email
                        (set below) will receive these emails.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Learner Redirection URL
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        value={form.preferences.learnerRedirectionURL}
                        name="preferences.learnerRedirectionURL"
                        type="text"
                        placeholder="e.g. http://www.tlrg.com.au"
                        className="form-control input-md"
                        required
                      />
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        When a learner completes a quiz they will be directed to
                        this website. Please ensure that you include the 'http'
                        section of your website e.g. 'http://www.tlrg.com.au'
                        instead of 'tlrg.com.au'.
                        <br />
                        <br />
                        This website is generally set as your organisation's
                        home page. Some companies have created a custom page
                        detailing what learners should do after completing the
                        quiz.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Learner Correspondence Name
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        value={form.preferences.learnerCorrespondence.name}
                        name="preferences.learnerCorrespondence.name"
                        type="text"
                        placeholder="e.g. John Smith"
                        className="form-control input-md"
                        required
                      />
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        This is the sender name that will be shown to learners
                        on their invitation email. This should be a name they
                        will recognise or the name of your organisation.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Learner Correspondence Email
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        value={form.preferences.learnerCorrespondence.email}
                        name="preferences.learnerCorrespondence.email"
                        type="email"
                        placeholder="e.g. support@tlrg.com.au"
                        className="form-control input-md"
                        required
                      />
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        This is the email address that learners will reply to
                        for all learner invitation emails. This should be set as
                        an email address that the learner will recognise and is
                        monitored so learners can contact you for assistance.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Learner Correspondence Phone
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        value={form.preferences.learnerCorrespondence.phone}
                        name="preferences.learnerCorrespondence.phone"
                        type="text"
                        placeholder="e.g. 1300 221 729"
                        className="form-control input-md"
                        required
                      />
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        This is the phone number that will be displayed to a
                        learner. This should be set as a phone number that the
                        learner can contact for assistance.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Admin Correspondence Name
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        value={form.preferences.adminCorrespondence.name}
                        name="preferences.adminCorrespondence.name"
                        type="text"
                        placeholder="e.g. John Smith"
                        className="form-control input-md"
                        required
                      />
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        This is the name that will be displayed to staff members
                        as the sender on their invitation email. This should be
                        set as an individual name that they will recognise or
                        set as the name of your organisation.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Admin Correspondence Email
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        value={form.preferences.adminCorrespondence.email}
                        name="preferences.adminCorrespondence.email"
                        type="email"
                        placeholder="e.g. support@tlrg.com.au"
                        className="form-control input-md"
                        required
                      />
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        This is the email address that will receive all of the
                        automatic notification emails from the LLN Robot System
                        (e.g. the Daily Quiz Summary Email)
                        <br />
                        <br />
                        This is also the email address that will send all LLN
                        Robot System user invitation emails. This should be set
                        as an email address that staff members will recognise
                        and is monitored so they can contact you for assistance.
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-4" />
                  <div className="col-md-6">
                    <h4>Company Information</h4>
                    <p className="text-muted">
                      This section contains information on your company.
                    </p>
                  </div>
                  <div className="col-md-2" />
                </div>

                <div className="row">
                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Company Name
                    </label>
                    <div className="col-md-6">
                      <input
                        onChange={this.onChange}
                        value={form.companyName}
                        name="companyName"
                        type="text"
                        placeholder="e.g. The Learning Resources Group"
                        className="form-control input-md"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Logo Upload
                    </label>
                    <div className="col-md-3">
                      <div className="input-group">
                        <span style={{ color: 'white' }}>Choose File:</span>
                        <FileInput
                          onChange={this.onChangeLogo}
                          name="logo"
                          accept=".png,.jpg,.jpeg,.gif"
                          className="btn btn-default btn-file input-file"
                          placeholder="Click here to select."
                        />
                        {logoError && <p style={{ color: '#e74c3c', marginTop: 5 }}>{logoError}</p>}
                      </div>
                    </div>
                    <div className="col-md-3">
                      {logoPreview &&
                        <div style={{ color: 'white' }}>
                          Logo Preview:
                          <div
                            style={{
                              backgroundColor: 'white',
                              padding: 10,
                              textAlign: 'center',
                            }}>
                            <img
                              src={logoPreview}
                              style={{ maxWidth: 180, maxHeight: 120 }}
                              alt="Logo preview."
                            />
                          </div>
                        </div>}
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        Please ensure your logo is at least 300px wide & in a
                        PNG or JPG format.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">
                      Deployment Subdomain
                    </label>
                    <div className="col-md-6">
                      <div className="input-group">
                        <input
                          onChange={this.onChange}
                          value={form.requestedSubdomain}
                          name="requestedSubdomain"
                          className="form-control"
                          type="text"
                          placeholder="e.g. tlrg"
                        />
                        <span className="input-group-addon">.lln.training</span>
                      </div>
                    </div>
                    <div className="col-md-6 col-md-offset-4">
                      <p className="text-muted">
                        This is the URL that your learners will use to access
                        the online quiz. This should be consistent with your
                        organisation's name or branding.
                      </p>
                    </div>
                  </div>
                </div>
                <hr />

                <div className="row">
                  <div className="col-md-6 col-md-offset-4">
                    <h4>Default Test</h4>
                    <p className="text-muted">
                      Please select the default test for learners to take:
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="form-group">
                    <div className="col-md-6 col-md-offset-4">
                      <select
                        onChange={this.onChange}
                        value={form.preferences.defaultQuizLevel}
                        className="form-control"
                        name="preferences.defaultQuizLevel">
                        <option value="acsf3">
                          Basic (Suitable for courses up to Cert IV)
                        </option>
                        <option value="acsf4">
                          Advanced (Suitable for courses Cert IV and above)
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-md-offset-4">
                    <p className="text-muted">
                      Note: You can change this setting at any time within the
                      system, and you will still have access to both versions of
                      the test when inviting learners.
                    </p>
                  </div>
                </div>

                <hr />
                <div className="row">
                  <div className="col-md-6 col-md-offset-4">
                    <h4>System Users</h4>
                    <p className="text-muted">
                      Please enter the information of staff members you would
                      like to add as users to your LLN Robot System.
                    </p>
                    <div className="wrapper" style={{ textAlign: 'center' }}>
                      <button
                        type="button"
                        className="btn btn-primary btn-lg button"
                        onClick={this.toggleUserInformationModal}>
                        Information on User Roles
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div id="adminUsersHolder">
                    {form.users.map((user, i) =>
                      <div key={i}>
                        <div className="col-md-4" />
                        <div className="col-md-8">
                          <h4>LLN Robot System User</h4>
                          {i !== 0 &&
                            <span style={{ paddingLeft: 10 }}>
                              <button
                                className="btn btn-danger"
                                type="button"
                                onClick={this.removeAdminUser(i)}>
                                X
                              </button>
                            </span>}
                        </div>

                        <div className="form-group">
                          <label className="col-md-4 control-label">
                            First Name
                          </label>
                          <div className="col-md-6">
                            <input
                              onChange={this.onChange}
                              value={user.name.first}
                              name={`users.${i}.name.first`}
                              type="text"
                              placeholder="e.g. John"
                              className="form-control input-md"
                              required=""
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label className="col-md-4 control-label">
                            Last Name
                          </label>
                          <div className="col-md-6">
                            <input
                              onChange={this.onChange}
                              value={user.name.last}
                              name={`users.${i}.name.last`}
                              type="text"
                              placeholder="e.g. Smith"
                              className="form-control input-md"
                              required=""
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label className="col-md-4 control-label">
                            Email
                          </label>
                          <div className="col-md-6">
                            <input
                              onChange={this.onChangeEmail}
                              value={user.email}
                              name={`users.${i}.email`}
                              type="email"
                              placeholder="e.g. support@tlrg.com.au"
                              className="form-control input-md"
                              required=""
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label className="col-md-4 control-label">Role</label>
                          <div className="col-md-6">
                            <select
                              required
                              value={user.role}
                              className="form-control"
                              onChange={this.onChange}
                              name={`users.${i}.role`}>
                              <option value="" disabled="true">
                                Please Select
                              </option>
                              <option value="Administrator">
                                Administrator
                              </option>
                              <option value="LLN Specialist">
                                LLN Specialist
                              </option>
                              <option value="Enrolment Officer">
                                Enrolment Officer
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>,
                    )}
                  </div>
                  <div className="col-md-8 col-md-offset-4">
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={this.addAdminUser}>
                      Add LLN Robot System User{' '}
                      <span className="glyphicon glyphicon-plus" />
                    </button>
                  </div>
                </div>
                <hr />

                <div className="form-group">
                  <div className="col-md-10">
                    <span id="submit-container" style={{ float: 'right' }}>
                      <button
                        type="submit"
                        value="Submit"
                        className="btn btn-success"
                        id="submit">
                        Submit
                      </button>
                    </span>
                  </div>
                </div>
              </fieldset>
            </form>}
        </div>
      </div>
    )
  }
}

export default DeploymentRequest



// WEBPACK FOOTER //
// ./src/DeploymentRequest.js